import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbSincronizar } from 'app/abstract/full-pages/credencial/sincronizar.abstract';
import { ColetaDto } from 'app/models/coleta-dto';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SincronizarService extends AbSincronizar {
    prefixo = 'sincronizar/';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public getSincGeral(): Observable<any> {
        return this.get(`${this.prefixo}geral`);
    }

    public getSincPorPerfilId(perfilId: number): Observable<any> {
        return this.get(`${this.prefixo}porPerfil/${perfilId}`);
    }

    public getSincPorDispositivoId(dispositivoId: number): Observable<any> {
        return this.get(`${this.prefixo}porDispositivo/${dispositivoId}`);
    }

    public getSincPorUsuarioCredencialId(usuarioId: number): Observable<any> {
        return this.get(`${this.prefixo}porPessoa/${usuarioId}`);
    }

    public postColeta(coletaDTO: ColetaDto) {
        return this.post(`${this.prefixo}coleta`, coletaDTO);
    }

    public postColetaPanico(coletaDTO: ColetaDto) {
        return this.post(`${this.prefixo}coleta/panico`, coletaDTO);
    }
}
